import React from "react";
import { FormGroup, Col, Row, Container } from "react-bootstrap";
import { connect } from "react-redux";

import { Button } from "components";
import { URLS } from "globalConstants";
import { history } from "helpers";
import { userActions } from "store";

import { ReactComponent as Logo } from "static/images/logo.svg";
import { ReactComponent as CrmLogo } from "static/images/riseCrm.svg";
import styles from "./forgotPassword.module.scss";

class ForgotPasswordPage extends React.Component {
	state = {
		username: "",
		email: "",
		nameError: "",
		emailError: "",
	};

	componentDidMount = () => {
		if (!this.props.location.state) {
			history.push(URLS.login);
			return;
		}
		const { username } = this.props.location.state;
		this.setState({ username });
	};

	clearErrors = () => {
		this.setState({
			nameError: "",
			emailError: "",
		});
	};

	validateForm = () => {
		/* eslint-disable no-useless-escape */
		const emailRegex =
			/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
		this.clearErrors();
		let isValid = true;

		if (this.state.username.length === 0) {
			this.setState({ nameError: "Username is required" });
			isValid = false;
		}
		if (this.state.email.length === 0) {
			this.setState({ emailError: "Email is required" });
			isValid = false;
		} else if (!emailRegex.test(this.state.email)) {
			this.setState({ emailError: "Invalid email" });
			isValid = false;
		}

		return isValid;
	};

	handleChange = e => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	okClick = () => {
		let isValid = this.validateForm();
		if (isValid) {
			this.props
				.dispatch(
					userActions.forgotPassword(
						this.state.username,
						this.state.email,
					),
				)
				.then(() => {
					this.props.history.push("/forgot-password-success");
				})
				.catch(code => {
					if (code === 404) {
						this.setState({
							emailError: "User not found or inactive",
						});
					}
				});
		}
	};

	cancelClick = () => {
		this.props.history.goBack();
	};

	render() {
		return (
			<Container>
				<Row className={styles.login}>
					<Col
						className={styles.loginBlock + " align-self-center"}
						md={{ span: 8, offset: 2 }}
					>
						<Col md={{ span: 8, offset: 2 }}>
							<div className={styles.logosHolder}>
								<Logo className={styles.mainLogo} />
								<CrmLogo className={styles.secondaryLogo} />
							</div>
							<div className={styles.welcomBlock}>
								<span className={styles.welcomeText}>
									<h2>
										<b className="">Forgot password</b>
									</h2>
									<div>
										Use the instructions to create a new
										password.
									</div>
								</span>
							</div>
							<div className={styles.loginForm}>
								<span>
									<FormGroup>
										<label htmlFor="username">
											Username
										</label>
										<input
											type="text"
											placeholder="Enter your username"
											className={
												"form-control " +
												(this.state.nameError.length !==
												0
													? "invalid"
													: "")
											}
											name="username"
											value={this.state.username}
											readOnly
										/>
										<span className="errorMessage">
											{this.state.nameError}
										</span>
									</FormGroup>
									<FormGroup>
										<label htmlFor="email">Email</label>
										<input
											type="email"
											placeholder="Enter your email"
											className={
												"form-control " +
												(this.state.emailError
													.length !== 0
													? "invalid"
													: "")
											}
											name="email"
											value={this.state.email}
											onChange={this.handleChange}
										/>
										<span className="errorMessage">
											{this.state.emailError}
										</span>
									</FormGroup>
									<FormGroup className="text-center">
										<Button
											onClick={this.cancelClick}
											variant="outline-primary"
											className={styles.cancelBtn}
											value="Cancel"
										/>
										<Button
											onClick={this.okClick}
											className={styles.okBtn}
											value="Ok"
										/>
									</FormGroup>
								</span>
								<div className="col-md-12 text-center hidden">
									<a className={styles.supportLink} href="#?">
										Need help? Call us at 1-833-AURORA2
									</a>
								</div>
							</div>
						</Col>
					</Col>
				</Row>
			</Container>
		);
	}
}

const forgotPasswordPage = connect()(ForgotPasswordPage);

export { forgotPasswordPage as ForgotPasswordPage };
